// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import 'slick-carousel/slick/slick.min';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

$(document).ready(function(){
  //slick init
  $('.view-slider').slick({
    arrows: false,
		dots: true,
		infinite: true,
		slidesToShow: 1,
		autoplay: true,
		pauseOnHover: false,
		autoplaySpeed: 10000,
	});

	//hide nav
	$(function() {
		var lastScrollTop = 0;
		$(window).on('scroll', function(){
		var st = $(this).scrollTop();
		if (st > lastScrollTop){
			$('.nav-primary').css('transform','translateY(-70px)').show();
		} else {
			$('.nav-primary').css('transform','translateY(0)').show();
		}
		lastScrollTop = st;
		});
	});

	//menu-burger
	$(function() {
		var box = $('.hidden-menu');
		var button = $('.menu');
		var burger = $('.burger');
		button.on('click', function(){
			box.toggleClass('is-open');
			burger.toggleClass('rotate');
		});
		$('.hidden-menu li a').on('click', function() {
			box.toggleClass('is-open');
			burger.toggleClass('rotate');
		});
	});
});



// WEBPACK FOOTER //
// ./scripts/main.js